<template>
  <module-block
    block="transparent"
    class="home-understanding-report"
  >
    <div class="home-understanding-report__inner group group--first-last">
      <div class="home-dentists__content">
        <h1 class="home-hero__heading h1 mt0 fw-semibold">{{ heading }}</h1>
        <p
          v-for="(p, index) in copy"
          :key="index"

          class="p"

          v-html="p"
        />
      </div>
      <div
        :class="[
          `home-dentists__image`,
          `home-dentists__image--${animationClass ? `open` : `closed`}`,
        ]"
      >
        <div class="home-dentists__image-wrapper">
          <img
            v-for="(image, index) in images.pages"
            :key="index"

            :class="[
              `home-dentists__paper`,
              `home-dentists__paper--${index}`,
            ]"

            :src="image"
          >
        </div>
      </div>
    </div>
  </module-block>
</template>

<script>
// Services
import { createScroll, destroyScroll } from 'services/scroll';

// Modules
import ModuleBlock from 'modules/Block';
import ModuleForm from 'modules/Form';

// Images
const images = {
  pages: {
    'four': require(`images/home/dentists-page-3.svg`),
    'three': require(`images/home/dentists-page-2.svg`),
    'two': require(`images/home/dentists-page-4.svg`),
    'one': require(`images/home/dentists-page-1.svg`),
  },
};

// Export
export default {
  name: `understanding-your-report-hero`,

  // Compononts
  components: {
    ModuleBlock,
    ModuleForm,
  },

  // Data
  data () {
    return {
      animationClass: false,
      images,
      heading: `Understanding Your VeriTooth Report`,
      copy: [
        `Knowing the difference between a good and bad root canal is challenging. ` +
        `But we’re trying to make it a bit easier for you. Your VeriTooth report ` + 
        `provides a snapshot, comparing the x-rays your dentist provided against ` +
        `specific criteria as defined by the <a class="link link--secondary tdn" ` +
        `href="https://www.aae.org/" target="_blank">AAE (American Association of Endodontics)</a>.`,
        `The following article includes an introduction into how experts arrived at `+
        `the findings of your report and what they were looking for.`,
      ],
    };
  },

  // Methods
  methods: {
    animation() {
      this.animationClass = !this.animationClass;
    },
  },

  // Lifecycle
  mounted() {
    createScroll(`dentists-papers`, {
      el: this.$el,
      move: e => {
        if(e.top.topPercent >= -50) {
          this.animationClass = true;
        }
        else if (e.top.topPercent < -100) {
          this.animationClass = false;
        }
      },
    });
  },
  destroyed() {
    destroyScroll(`dentists-papers`);
  },
};
</script>



// WEBPACK FOOTER //
// Hero.vue?5793a7f4